import { createSlice } from "../../helper";

const expenseFormSlice = createSlice({
  name: "expenseForm",
  initialState: {},
  reducers: {
    replaceExpenseForm(_state, action) {
      return action.payload.data;
    },
    updateFieldData(state, action) {
      const { field, fieldData } = action.payload;
      state[field] = fieldData;
    },
    updateAnswerFieldData(state, action) {
      const { field, fieldData } = action.payload;
      state.questionAndAnswerDetails[field] = fieldData;
    },
    updateAttachments(state, action) {
      state.attachments = action.payload;
    },
    setIsFileUploading(state, action) {
      state.isFileUploading = action.payload;
    }
  }
});

export const expenseFormActions = expenseFormSlice.actions;

export default expenseFormSlice.reducer;
